import { Link } from 'react-router-dom';
import { ChevronRight, ArrowLeft } from 'lucide-react';

/**
 * Breadcrumb cliccabile + back coerente.
 *
 * items: [{ label: string, to?: string }]
 * L'ultimo item è la pagina corrente (non linkata).
 *
 * Esempio:
 *   <Breadcrumb items={[
 *     { label: 'Dashboard', to: '/' },
 *     { label: 'Obiettivo 03', to: `/obiettivo/${id}` },
 *     { label: 'Q2 · Fatturato' }
 *   ]} />
 */
export default function Breadcrumb({ items = [], backTo, backLabel = 'Indietro' }) {
  return (
    <nav
      className="flex items-center gap-3 py-4 text-xs font-mono uppercase tracking-[0.18em] text-soft"
      data-testid="breadcrumb"
      aria-label="Percorso"
    >
      {backTo && (
        <Link
          to={backTo}
          className="inline-flex items-center gap-1.5 hover:text-ink transition-colors mr-2"
          data-testid="breadcrumb-back"
        >
          <ArrowLeft size={12} strokeWidth={1.5} /> {backLabel}
        </Link>
      )}
      <ol className="flex items-center gap-2 flex-wrap">
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${i}-${it.to || it.label}`} className="flex items-center gap-2">
              {it.to && !isLast ? (
                <Link to={it.to} className="hover:text-ink transition-colors" data-testid={`breadcrumb-item-${i}`}>
                  {it.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-ink' : ''} data-testid={`breadcrumb-item-${i}`}>
                  {it.label}
                </span>
              )}
              {!isLast && <ChevronRight size={11} strokeWidth={1.5} className="opacity-50" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
